import { Typography } from '@mui/material';
import { ArrowDownIcon } from '../../../../../../../assets/images';
import { MuiIconButton } from '../../../../../../../builderPackage/components';
import { MuiStack } from '../../../../../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../../../../../constants';
import { getLocalStorageItem } from '../../../../../../../utils/storageHelper';
export default function InwardSourceLocationCell(props) {
    var _props$row, _props$row2, _props$row3, _props$row4, _props$row5;
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var isDisable = isMulitpleDoc;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
    }, (props === null || props === void 0 || (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.SourceLocations) && (props === null || props === void 0 || (_props$row2 = props.row) === null || _props$row2 === void 0 || (_props$row2 = _props$row2.SourceLocations) === null || _props$row2 === void 0 ? void 0 : _props$row2.map(function (data) { /*#__PURE__*/ return React.createElement(Typography, {
        variant: "h5",
        style: {
            fontSize: '12px',
            fontWeight: 400,
            color: '#1B1D21'
        }
    }, data !== null && data !== void 0 && data.LocationName ? data === null || data === void 0 ? void 0 : data.LocationName : ''); })), ((_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.SourceLocations) && !((_props$row4 = props.row) !== null && _props$row4 !== void 0 && _props$row4.SourceLocations) && /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: props.onClick,
        style: {
            alignContent: 'flex-end'
        },
        disable: ((_props$row5 = props.row) === null || _props$row5 === void 0 || (_props$row5 = _props$row5.SourceLocations[0]) === null || _props$row5 === void 0 ? void 0 : _props$row5.LocationId) || isDisable
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        alt: "Arrow Down"
    }))));
}
